exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".coaching-tip-container{height:80%;width:100%;overflow:auto;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:24px;color:#fff}@media(max-width:992px){.coaching-tip-container{height:100%;justify-content:flex-start;padding-inline:25px}.coaching-tip-container h3{margin-top:20px;font-size:20px}}.coaching-tip-container .logo-animation{height:100px}", ""]);

// exports
